/* eslint-disable prettier/prettier */
const TYPES = {
    ADD_AUTORIDADT: 'ADD_AUTORIDADT',
    ADD_AUTORIDADT_SUCCESS: 'ADD_AUTORIDADT_SUCCESS',
    ADD_AUTORIDADT_ERROR: 'ADD_AUTORIDADT_ERROR',
    EDITAR_AUTORIDADT: 'EDITAR_AUTORIDADT',
    EDITAR_AUTORIDADT_SUCCESS: 'EDITAR_AUTORIDADT_SUCCESS',
    EDITAR_AUTORIDADT_ERROR: 'EDITAR_AUTORIDADT_ERROR',
    OBTENER_AUTORIDADT_EDITAR: 'OBTENER_AUTORIDADT_EDITAR',
    OBTENER_AUTORIDADT: 'OBTENER_AUTORIDADT',
    OBTENER_AUTORIDADT_SUCCESS: 'OBTENER_AUTORIDADT_SUCCESS',
    OBTENER_AUTORIDADT_ERROR: 'OBTENER_AUTORIDADT_ERROR',
    DELETE_AUTORIDADT: 'DELETE_AUTORIDADT:',
    DELETE_AUTORIDADT_SUCCESS: 'DELETE_AUTORIDADT_SUCCESS',
    DELETE_AUTORIDADT_ERROR: 'DELETE_AUTORIDADT_ERROR',
}

export default TYPES
